/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Source_Readonly_TitleInputs */



/**
* | output |
* | --- |
* | "Wundo writes nothing back" |
*
* @param {Agenda_Source_Readonly_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_source_readonly_title = /** @type {((inputs?: Agenda_Source_Readonly_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Source_Readonly_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo schrijft niets terug")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo n'écrit rien en retour")
	return /** @type {LocalizedString} */ ("Wundo writes nothing back")
});